import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import Routes from './routes/Routes';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { AuthContext } from './components/authentication/AuthContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './index.scss';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import { NotificationProvider } from './components/notifications/NotificationContext';
import { NotificationBell } from './components/notifications/NotificationUI';
import { WhatsAppBell } from './components/notifications/WhatsAppPainel';
import SocketListener from './components/socketListener/SocketListener';
import ListenerSolicitacaoSenha from './components/partials/ListenerSolicitacaoSenha';

import { BannerProvider } from './components/banners/BannerContext';
import BannerBar from './components/banners/BannerBar';

import { GlobalAudioProvider } from './components/audio/GlobalAudioContext';

const GlobalFloatingElements = () => {
  const location = useLocation();
  const isAppRoute = location.pathname.startsWith('/app');
  const isTesteGratuito = location.pathname === '/teste-gratuito';
  const isLoginSemOrg = location.pathname === '/login';
  const isPaginaBalanca = location.pathname.startsWith('/balanca');
  // Site/loja/mesa são rotas públicas do cardápio, usadas por clientes sem
  // sessão autenticada — o sino do WhatsApp faz polling de endpoints que
  // exigem auth (/api/telefone/...), gerando 401 repetido à toa nessas
  // páginas (achado em 2026-09-22 testando a tela de confirmação de
  // endereço). Mesmo critério de rota pública usado em routes/Routes.js.
  const isRotaPublicaCardapio =
    location.pathname.startsWith('/menu') ||
    location.pathname.startsWith('/loja') ||
    location.pathname.startsWith('/mesa');

  if (isAppRoute || isTesteGratuito || isLoginSemOrg || isPaginaBalanca) return null;

  return (
    <>
      {!isRotaPublicaCardapio && <WhatsAppBell />}
      <NotificationBell />
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthContext>
        <NotificationProvider>
          <BannerProvider>
            <GlobalAudioProvider>
              <Routes />

              {/* Banner de avisos urgentes (topo) */}
              <BannerBar />

              {/* Renderiza o WhatsApp e o Sino condicionalmente */}
              <GlobalFloatingElements />

              {/* Escuta de mensagens por socket (global) */}
              <SocketListener />

              {/* Painel de aprovação de senha de exclusão (só GERENTE/ADMINISTRADOR) */}
              <ListenerSolicitacaoSenha />
            </GlobalAudioProvider>
          </BannerProvider>
        </NotificationProvider>
      </AuthContext>

      {/* (Opcional) Toasts globais para outros usos */}
      <ToastContainer autoClose={2500} />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
